import { httpClient } from '../http/httpClient'

export interface CreateTableParams {
  name: string
  tableCode: string
  percents: number
  bonus?: number
  leaderCommission?: number
}

export const createTable = async (params: CreateTableParams) => {
  const { data } = await httpClient.post('/table', params).catch((error) => {
    throw error.response.data
  })

  return data
}
